export enum CompanyTag {
  BCFD = 'BCFD',
  AN_FARM = 'AN_FARM',
}

export const COMPANY_TAG_OPTIONS = [
  { value: CompanyTag.BCFD, label: 'BCFD' },
  { value: CompanyTag.AN_FARM, label: 'AN_FARM' },
];

export enum VehicleType {
  AUTO = 'AUTO',
  BIKE = 'BIKE', 
  FOUR_WHEELER_EV = 'FOUR_WHEELER_EV',
}

export const VEHICLE_TYPE_OPTIONS = [
  {
    value: VehicleType.AUTO,
    label: 'AUTO',
  },
  {
    value: VehicleType.BIKE,
    label: 'BIKE',
  },
  {
    value: VehicleType.FOUR_WHEELER_EV,
    label: 'FOUR_WHEELER_EV',
  },
];

export const getVehicleTypeLabel = (vehicleType: string): string => {
  const option = VEHICLE_TYPE_OPTIONS.find(opt => opt.value === vehicleType);
  return option ? option.label : vehicleType || '';
};

// Available Orders - Slot configuration (ID to time range mapping)
export const SLOT_CONFIG = {
  22: '8:30AM-9AM',
  21: '8AM-8:30AM',
  20: '7:30AM-8AM',
  19: '7AM-7:30AM',
  18: '6:30AM-7AM',
  17: '6AM-6:30AM',
  11: 'before 7:30AM',
  12: 'before 9:00AM',
  13: 'before 10:00AM',
} as const;

// Allowed slot IDs derived from SLOT_CONFIG
export const ALLOWED_SLOT_IDS = Object.keys(SLOT_CONFIG).map(Number);

// Helper function to get slot value from ID
export const getSlotValue = (slotId?: number): string => {
  if (!slotId || !(slotId in SLOT_CONFIG)) {
    return 'N/A';
  }
  return SLOT_CONFIG[slotId as keyof typeof SLOT_CONFIG];
};
